import React, { useRef, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios, { cookies } from "../axios/axios";
import { ToastContainer, toast } from "react-toastify";
import logo from "../images/logo.jpg";
import RecaptchaField, {
  isRecaptchaConfigured,
} from "../Components/RecaptchaField";

const Login = () => {
  const [errorMessage, seterrorMessage] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const recaptchaRef = useRef(null);

  const [login, setLogin] = useState({
    email: "",
    password: "",
  });
  const loginHandler = (e) => {
    const { name, value } = e.target;
    setLogin({ ...login, [name]: value });
  };

  const loginSubmit = async (e) => {
    e.preventDefault();
    if (isRecaptchaConfigured && !captchaToken) {
      toast.error("Please complete the captcha.");
      return;
    }
    try {
      const response = await axios.post("/auth/login", {
        ...login,
        captchaToken,
      });
      const data = response.data;
      toast.success("Logged in successfully!");

      cookies.set("user", data, { path: "/" });

      if (data.user.role === "admin") {
        window.location.href = "/user-table";
      } else if (data?.user?.role === "manager") {
        window.location.href = "/realestate-manager";
      } else if (data?.user?.role === "editor") {
        window.location.href = "/realestate-editor";
      } else {
        window.location.href = "/";
      }
    } catch (error) {
      seterrorMessage(error.response?.data?.message || "An error occurred");
      toast.error(error.response?.data?.message || "An error occurred");
      recaptchaRef.current?.reset();
      setCaptchaToken("");
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <div style={{ minHeight: "100vh" }} className="bg-light">
      <Navbar />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="bg-white col-md-8 mx-auto row px-4 py-5 my-5">
        <h1 className="amaranth-regular fw-bold text-center mb-4">
          {" "}
          <Link to={"/"} className="navbar-brand">
            <img src={logo} width={250} height={150} alt="" />
          </Link>{" "}
        </h1>
        <div className="col-md-6 pe-md-5">
          <h4 className="text-center fw-bold prata-regular">Sign Up Now</h4>
          <p className="fs-14 py-4" style={{ textAlign: "justify" }}>
            In order to place an order, you must first set up an account. With a
            little more information and a quick approval process, we can have
            you up and running in no time. Inside the members section you can
            place orders, view past history, upload your images, and more.
          </p>
          <Link to={"/signup"} className="btn bg_maincolor fs-14 text-white">
            Create An Account
          </Link>
        </div>
        <form onSubmit={loginSubmit} className="col-md-6">
          <h4 className="text-center fw-bold prata-regular mb-4">
            Member Login
          </h4>

          <div class="mb-3">
            <input
              onChange={loginHandler}
              type="email"
              name="email"
              value={login.email}
              placeholder="Email"
              class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>
          <div class="mb-3">
            <div class="position-relative d-flex align-items-center">
              <input
                onChange={loginHandler}
                name="password"
                value={login.password}
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
              />
              <div
                class=" position-absolute top-50 end-0 me-3 translate-middle-y cursor-pointer"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>
          </div>
          <div class="mb-3">
            <a href="/forgot-password" class="text-dark fs-15 mb-0">
              Forgot Password?
            </a>
          </div>
          <RecaptchaField ref={recaptchaRef} onChange={setCaptchaToken} />
          <button
            type="submit"
            name="submit"
            class="btn bg_maincolor text-light"
          >
            Submit
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
